import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

export function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirm) { setError('Passwörter stimmen nicht überein'); return; }
    if (newPassword.length < 12) { setError('Mindestens 12 Zeichen'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/password/change', { currentPassword, newPassword });
      await refresh();
      nav('/login');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Fehler');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-xl font-bold text-center mb-6">Passwort ändern</h1>
        <form onSubmit={submit} className="card space-y-4">
          {error && <div className="bg-red-50 text-red-700 text-sm rounded-md px-3 py-2">{error}</div>}
          <div>
            <label className="label">Aktuelles Passwort</label>
            <input type="password" className="input" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <div>
            <label className="label">Neues Passwort (min. 12 Zeichen)</label>
            <input type="password" className="input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={12} autoComplete="new-password" />
          </div>
          <div>
            <label className="label">Passwort bestätigen</label>
            <input type="password" className="input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? 'Speichere ...' : 'Passwort ändern'}
          </button>
        </form>
      </div>
    </div>
  );
}
